// extracted by mini-css-extract-plugin
module.exports = {"navi":"CompanyForm__navi--2dGGk","form":"CompanyForm__form--CEPIb"};